var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('ImportForm',{attrs:{"loading":_vm.loading,"importData":_vm.importation,"formErrors":_vm.formErrors},on:{"importSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }